export const TIMEZONE: string = 'Europe/Kyiv';